import { render, staticRenderFns } from "./BaseTooltip.vue?vue&type=template&id=258d2276&lang=pug"
import script from "./BaseTooltip.vue?vue&type=script&lang=js"
export * from "./BaseTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VProgressCircular,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('258d2276')) {
      api.createRecord('258d2276', component.options)
    } else {
      api.reload('258d2276', component.options)
    }
    module.hot.accept("./BaseTooltip.vue?vue&type=template&id=258d2276&lang=pug", function () {
      api.rerender('258d2276', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/BaseTooltip.vue"
export default component.exports